import { useMutation, UseMutationConfig } from '@libs/use';

import * as API from '../requests';
import { physicalSettlementFactory } from '../utils/settlement';

type TUseCreatePhysicalSettlementQueryConfigs = {
  onReject?: UseMutationConfig<any>['onReject'];
  onSuccess?: UseMutationConfig<any>['onSuccess'];
};

export default function useCreatePhysicalSettlementQuery({
  onReject,
  onSuccess,
}: TUseCreatePhysicalSettlementQueryConfigs) {
  const {
    isPending: isLoadingCreatePhysicalSettlement,
    isError: isErrorCreatePhysicalSettlement,
    execute: createPhysicalSettlement,
    isSuccess: isSuccessCreatePhysicalSettlement,
    ...query
  } = useMutation(
    ({ formModel }) =>
      API.createPhysicalSettlement(physicalSettlementFactory(formModel)),
    {
      onReject,
      onSuccess,
    }
  );

  return {
    createPhysicalSettlement,
    isErrorCreatePhysicalSettlement,
    isLoadingCreatePhysicalSettlement,
    isSuccessCreatePhysicalSettlement,
    query,
  };
}
